/**
 * VIB-1189: faktureringsstatus fra fakturert beløp vs. kontraktssum.
 *
 * Delt kilde for både prosjektkortet (ProjectHeader) og prosjektlista
 * (ProjectTable), så tersklene ikke kan divergere. Begge beløp skal være
 * EKS. mva (fakturert = Σ invoices.amount_excl_vat ?? amount, kontrakt =
 * projects.total_amount). Jf. ProjectDetailLayout som regner invoicedAmount.
 */

export type InvoiceStatusIcon = "full" | "partial" | "none";

export interface InvoiceStatusResult {
  label: "Ikke fakturert" | "Delvis fakturert" | "Fakturert";
  icon: InvoiceStatusIcon;
  /** Tailwind-bakgrunn for chip/badge. */
  bg: string;
  /** Tailwind-tekstfarge for chip/badge. */
  text: string;
}

const NONE: InvoiceStatusResult = {
  label: "Ikke fakturert",
  icon: "none",
  bg: "bg-card",
  text: "text-muted-foreground",
};

export function getInvoiceStatus(invoiced: number, total: number): InvoiceStatusResult {
  if (total <= 0) return NONE;
  const pct = (invoiced / total) * 100;
  if (pct >= 99) return { label: "Fakturert", icon: "full", bg: "bg-[#D9F5E8]", text: "text-[#035C39]" };
  if (pct > 0) return { label: "Delvis fakturert", icon: "partial", bg: "bg-[#FEF3C7]", text: "text-[#78350F]" };
  return NONE;
}
